<template>
  <div class="content-warp">
    <div class="menu-tab-warp bg-white">
      <div class="menu-tab-left">
        <a-menu
          mode="inline"
          :style="{ border: '0', width: 'auto'}"
          :selectedKeys="[selectedTab]"
          type="inner"
          @click="handleTabMenuClick"
        > 
          <a-menu-item key="cardSn">{{$t('repeatData.tabRepeatingCard')}}</a-menu-item>
          <a-menu-item key="idNumber">{{$t('repeatData.tabRepeatingId')}}</a-menu-item>
        </a-menu>
      </div>
      <div class="menu-tab-right">
        <a-row :gutter="24" class="content-panle margin-0 padding-tb-0">
          <a-col :span="12" class="padding-tb-md">
            <h3 class="panle-head">
              {{$t('repeatData.repeatingDataList')}}
              <span style="color: #1890FF">({{repeatTableData.length}})</span>
            </h3>
            <a-table
              :columns="repeatTableColumns" 
              :dataSource="repeatTableData"
              :pagination="pagination"
              :loading="repeatTableLoading"
              @change="handlePageChange"
              :scroll="{ x:400, y: 500 }"
            >
              <template slot="operation" slot-scope="text, record">
                <a 
                  :style="{color: '#1890ff'}"
                  @click="record.operation.callback(record)"
                >
                  {{$t(record.operation.type)}}
                </a>
              </template>
            </a-table>
          </a-col>

          <a-col :span="12" class="padding-tb-md">
            <h3 class="panle-head">
              {{$t('repeatData.repeatingPersonList')}}
              <span style="color: #1890FF">({{personTableData.length}})</span>
            </h3>
            <a-table
              :columns="personTableColumns" 
              :dataSource="personTableData"
              :pagination="false"
              :loading="personTableLoading"
              :scroll="{ x:600, y: 500 }"
            >
              <template slot="operation" slot-scope="text, record">
                <a 
                  :style="{color: '#1890ff'}"
                  @click="record.operation.callback(record)"
                >
                  {{$t(record.operation.type)}}
                </a>
              </template>
            </a-table>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>

<script>
import { checkHasRepeatedPerson, getRepeatedPersonList } from '@/api/personalMana'

export default {
  name: 'repeatDataIndex',
  components: {},
  data() {
    return {
      selectedTab: 'cardSn',

      repeatTableColumns: this.getDataTableColumns(),
      repeatTableData: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      repeatTableLoading: false,

      searchPersonData: null,
      personTableColumns: this.getPersonTableColumns(),
      personTableData: [],
      personTableLoading: false
    }
  },
  watch: {
    '$store.state.lang': function (lang) {
      this.repeatTableColumns = this.getDataTableColumns()
      this.personTableColumns = this.getPersonTableColumns()
    }
  },
  computed: {},
  created() {
    this.getListData();
  },
  activated() {
    if (this.repeatTableData.length) {
      this.getListData();
      this.handleGetRepeatPerson();
    }
  },
  methods: {
    // 获取重复数据表头项目名
    getDataTableColumns() {
      return [
        {
          title: this.$t('repeatData.listDataNumber'),
          dataIndex: 'sameValue',
          width: '50%'
        },
        {
          title: this.$t('repeatData.listDataAmount'),
          dataIndex: 'amount',
          width: '30%'
        },
        {
          title: this.$t('repeatData.listDataOperation'),
          dataIndex: 'operation',
          width: 100,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' }
        }
      ]
    },
    // 获取重复人员表头项目名
    getPersonTableColumns() {
      return [
        {
          title: this.$t('repeatData.listPersonName'),
          dataIndex: 'name',
          width: '20%'
        },
        {
          title: this.$t('repeatData.listPersonOrganization'),
          dataIndex: 'deptFullName',
          width: '45%'
        },
        {
          title: this.$t('repeatData.listPersonPhone'),
          dataIndex: 'phone',
          width: '20%'
        },
        {
          title: this.$t('repeatData.listPersonOperation'),
          dataIndex: 'operation',
          width: 100,
          fixed: 'right',
          scopedSlots: { customRender: 'operation' }
        }
      ]
    },

    handleTabMenuClick(data) {
      // console.log('-handleTabMenuClick-', data)
      this.selectedTab = data.key;

      this.getListData();
      this.personTableData = [];
    },

    // 重复数据列表
    async getListData() {
      try {
        this.repeatTableLoading = true
        const res = await checkHasRepeatedPerson({
          type: this.selectedTab,
          perPage: this.pagination.pageSize,
          page: this.pagination.current
        })
        this.repeatTableLoading = false

        this.repeatTableData = res.data.collection.map((item, index) => {
          return {
            key: String(Math.random()),
            id: String(Math.random()),
            sameValue: item.sameValue,
            amount: item.amount,
            idType: item.idType,
            operation: {
              type: 'repeatData.listCheckBtn',
              callback: this.handleGetRepeatPerson
            }
          }
        })
        this.pagination.total = res.data.size
      } catch (error) {
        this.repeatTableLoading = false
      }
    },
    // 点击分页时触发
    handlePageChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current;
      this.getListData();
    },

    // 获取重复人员
    async handleGetRepeatPerson(data) {
      try {
        this.searchPersonData = data || this.searchPersonData
        if (!this.searchPersonData) return

        this.personTableLoading = true
        const res = await getRepeatedPersonList({
          cardSn: this.searchPersonData.sameValue,
          idNumber: this.searchPersonData.sameValue,
          idType: this.searchPersonData.idType
        })
        this.personTableLoading = false

        this.personTableData = res.data.collection.map((item, index) => {
          return {
            key: item.id,
            id: item.id,
            name: item.name,
            deptFullName: item.deptFullName,
            phone: item.phone,
            idType: item.idType,
            idNumber: item.idNumber,
            cardSn: item.cardSn,
            operation: {
              type: 'repeatData.listModifyBtn',
              callback: this.handleToPersonEditPage
            }
          }
        })
      } catch (error) {
        this.personTableLoading = false
      }
    },

    // 修改人员
    handleToPersonEditPage(data) {
      // console.log('---handleToPersonEditPage---', data)
      // this.$router.push({
      //   name: 'personalManaEdit',
      //   params: { targetItem: data }
      // })
      this.$router.push({
        path: '/personal-mana/edit',
        query: { 
          pi: data.id
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .menu-tab-warp {
    width: 100%;
    display: flex;
    // height: 100%;
    // overflow: auto;
    padding:16px 0;

    .menu-tab-left {
      border-right: 1px solid #e8e8e8;
      width: 224px;

      .ant-menu-item{
        text-align: center;
      }
    }

    .menu-tab-right {
      flex: 1 1;
      // padding: 0 25px;
      // min-height: 650px;
    }
  }
</style>